import Cookies from 'js-cookie'
const sso = {
  /* 重定向到登录 */
  redirectLogin () {
    const win = window as any
    const ssoWeb = win.ssoWeb
    window.location.href = ssoWeb.getLoginUrl(
      ssoWeb.createRedirectUrl(
        window.location.pathname + window.location.search + window.location.hash
      )
    )
  },
  /* 移除ssoid */
  removeSsoid () {
    Cookies.remove('ssoid')
  },
  /* 设置ssoid */
  setSsoid (ssoid: string) {
    Cookies.set('ssoid', ssoid)
  },
  /* 设置ssoid */
  getSsoid () {
    return Cookies.get('ssoid')
  },
  /* 设置当前URL */
  setCurrentURL () {
    const currentURL = window.location.href
    Cookies.set('currentURL', currentURL)
  },
  /* 获取ssoid */
  getCurrentURL () {
    return Cookies.get('currentURL') || '/'
  }
}

export default sso
